export * from './char-counter.directive';
export * from './char-counter.module';



// WEBPACK FOOTER //
// ./src/app/typescripts/pro/inputs/index.ts